<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A0uc05/tc-custom/9781473857360.jpg?1705634330450" alt="This image is the cover for the book History of the South Yorkshire Countryside"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History of the South Yorkshire Countryside
      </h1>
      <p class="bookDescription body article font2">
        <b>A look at how our ancestors shaped the South Yorkshire human landscape over the centuries from the author of <i>The Grass Roots of English History</i>.</b><br/><br/>South Yorkshire has some of the most varied countryside in England, ranging from the Pennine moors and the wooded hills and valleys in the west to the estate villages on the magnesian limestone escarpment and the lowlands in the east. Each of these different landscapes has been shaped by human activities over the centuries. This book tells the story of how the present landscape was created. It looks at buildings, fields, woods and moorland, navigable rivers and industrial remains, and the intriguing place-names that are associated with them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Hey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fdbc884